import { useQuery } from '@tanstack/react-query';
import api from '../api';
import Clients from '../pages/Clients';

export default function ClientProfileModal({ clientId, initialClient = null, onClose }) {
  const { data: clients, isLoading } = useQuery({
    queryKey: ['clients'],
    queryFn: () => api.get('/clients').then(r => r.data),
    enabled: Boolean(clientId) && !initialClient
  });

  const client =
    initialClient?.id === clientId
      ? initialClient
      : (Array.isArray(clients) ? clients.find(c => c.id === clientId) : null);

  if (!clientId) return null;

  if (isLoading && !client) {
    return (
      <div className="fixed inset-0 z-[14000] bg-black/50 flex items-center justify-center p-4">
        <div className="bg-[hsl(var(--ds-surface))] border border-[hsl(var(--ds-border))] rounded-xl px-6 py-4 text-sm text-[hsl(var(--ds-fg))] shadow-xl">
          Loading client…
        </div>
      </div>
    );
  }

  if (!client) {
    return (
      <div
        className="fixed inset-0 z-[14000] bg-black/50 flex items-center justify-center p-4"
        onClick={onClose}
      >
        <div
          className="bg-[hsl(var(--ds-surface))] border border-[hsl(var(--ds-border))] rounded-xl px-6 py-4 text-sm shadow-xl max-w-sm"
          onClick={e => e.stopPropagation()}
        >
          <p className="text-[hsl(var(--ds-fg))] mb-3">Could not load this client.</p>
          <button
            type="button"
            className="px-3 py-1.5 text-sm border border-[hsl(var(--ds-border))] hover:bg-[hsl(var(--ds-muted))] rounded-lg"
            onClick={onClose}
          >
            Close
          </button>
        </div>
      </div>
    );
  }

  return (
    <Clients embedded embeddedEditId={clientId} initialClient={client} onEmbeddedClose={onClose} />
  );
}
